import { useQuery } from "@apollo/client";
import { LoginState } from "@xingternal/crate-common-graphql-types";
import { UseLoginStateDocument } from "./use-login-state-query.gql-types";
function useLoginState() {
  var _a;
  const { data } = useQuery(UseLoginStateDocument, {
    fetchPolicy: "cache-first"
  });
  const loginState = (_a = data == null ? void 0 : data.viewer) == null ? void 0 : _a.loginState;
  const isLoggedIn = loginState === LoginState.LoggedIn;
  const isLoggedOut = loginState === LoginState.LoggedOut;
  const isSoftLoggedIn = loginState === LoginState.SoftLoggedIn;
  return {
    ...loginState && { loginState },
    isLoggedIn,
    isLoggedOut,
    isSoftLoggedIn
  };
}
export {
  useLoginState
};
